import { Flex } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";

import { RanaLoading } from "@nens/ranalib";

import { useRanaSearchDisclosure } from "@/hooks/router/rana-search-disclosure";
import { useRanaSearchState } from "@/hooks/router/rana-search-state";
import { getPublicationQuery } from "@/queries/query-publication";

import { PublicationStoreWrapper } from "./components/store-wrapper";
import { CreatePublication, PublicationList } from "./features/detail";

export const PUBLICATION_SEARCH_KEY = "publication"; // Exported because it is used in redirects
const CREATING_PUBLICATION_SEARCH_KEY = "creating";

export function PublicationOverview() {
  // Is the create publication modal open? We keep this here because there are
  // two ways to open it, with the button and the publication list if there
  // are no publications.
  const { isOpen, onClose, onOpen } = useRanaSearchDisclosure(CREATING_PUBLICATION_SEARCH_KEY);

  // Store the publication ID, if any, in URL params
  const [publicationId, setPublicationId] = useRanaSearchState<string | undefined>(
    PUBLICATION_SEARCH_KEY,
    undefined,
    ["string", "undefined"]
  );

  // Query for fetching the publication
  const publicationResponse = useQuery(getPublicationQuery(publicationId));

  if (publicationResponse.isLoading) return <RanaLoading isCentered />;

  const publication = publicationResponse.data;

  if (publication) {
    return (
      <PublicationStoreWrapper
        closePublication={() => setPublicationId(undefined)}
        publicationRead={publication}
      />
    );
  }

  return (
    <>
      <Flex mb={3} justifyContent="space-between">
        <CreatePublication
          setPublicationId={setPublicationId}
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
        />
      </Flex>

      <PublicationList setPublicationId={setPublicationId} onOpenCreateModal={onOpen} />
    </>
  );
}
